// referrer.service.ts
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ReferrerService {
    private referrerUrl: string = '';

    constructor(private router: Router) {
        // On first load: browser-provided referrer
        this.referrerUrl = document.referrer || '';

        // On SPA navigations: manually store previous full URL
        let previousUrl = window.location.origin + this.router.url;
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.referrerUrl = previousUrl;
                previousUrl = window.location.origin + event.urlAfterRedirects;
            }
        });
    }

    getReferrer(): string {
        return this.referrerUrl;
    }
}
